import React, { memo } from 'react'
import map from 'ramda/src/map'
import range from 'ramda/src/range'
import pipe from 'ramda/src/pipe'
import when from 'ramda/src/when'
import append from 'ramda/src/append'
import reduce from 'ramda/src/reduce'
import last from 'ramda/src/last'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import Icon, { iconParentStyle } from 'root/src/client/web/base/Icon'
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft'
import { gtSmMediaQuery, colorsNew, textShadow } from 'root/src/client/web/commonStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import is from 'ramda/src/is'

const calcPagination = (current, pagesAmount) => {
	const left = current - 2
	const right = current + 3
	const pagesArr = range(1, pagesAmount + 1)

	const pagesWithDots = reduce((acc, i) => {
		if ((i === 1 || i === pagesAmount) || (i >= left && i < right)) {
			const previousEl = last(acc)
			return pipe(
				when(
					() => !!previousEl,
					pipe(
						when(
							() => i - previousEl === 2,
							append(previousEl + 1),
						),
						when(
							() => i - previousEl !== 1,
							append('...'),
						),
					),
				),
				append(i),
			)(acc)
		}

		return acc
	}, [], pagesArr)

	return pagesWithDots
}

const styles = {
	pagerContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gap: 15,
	},
	arrowContainer: {
		...iconParentStyle,
		background: 'none',
		outline: 0,
		border: 0,

		[gtSmMediaQuery]: {
			cursor: 'pointer',
		},
	},
	pageNumber: {
		'&:hover': {
			textShadow: textShadow(colorsNew.primary),
		},
		[gtSmMediaQuery]: {
			cursor: 'pointer',
		},
	},
	currentPageNumber: {
		textDecoration: 'underline',
		textShadow: textShadow(colorsNew.primary),
		cursor: 'auto',
	},
	unselectable: {
		userSelect: 'none',
	},
	unclickable: {
		cursor: 'auto',
	},
}

const Pager = memo(({ classes, currentPage, allPage, getPage, className }) => {
	const rangeWithDots = calcPagination(currentPage, allPage)
	return (
		<div className={classNames(classes.pagerContainer, className)}>
			<button
				className={classNames(
					classes.arrowContainer,
					currentPage === 1 && classes.unclickable,
				)}
				type="button"
				onClick={() => currentPage !== 1 && getPage(currentPage - 1)}
			>
				<Icon
					icon={faAngleLeft}
					primary={false}
					glow={currentPage !== 1 && colorsNew.primary}
				/>
			</button>
			{ map(char => (
				<Typography
					variant={typographyVariants.smallBold}
					className={classNames(
						char === currentPage && classes.currentPageNumber,
						is(Number, char) ? classes.pageNumber : classes.unselectable,
					)}
					onClick={() => (is(Number, char) && char !== currentPage
						? getPage(char)
						: null
					)}
					key={char}
				>
					{char}
				</Typography>
			), rangeWithDots) }
			<button
				className={classNames(
					classes.arrowContainer,
					currentPage === allPage && classes.unclickable,
				)}
				type="button"
				onClick={() => currentPage !== allPage && getPage(currentPage + 1)}
			>
				<Icon
					icon={faAngleRight}
					primary={false}
					glow={currentPage !== allPage && colorsNew.primary}
				/>
			</button>
		</div>
	)
})

export default withStyles(styles, { name: 'MuiPager' })(Pager)
